/* eslint-disable no-undef */
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import Imagen from '../Imagen/Imagen';
import Botonera from '../Botonera/Botonera';
import useLoadImages from '../../hooks/useLoadImages';
import { generaListadoImagenes as generaListadoHorario } from '../../utils/generaListadoImagenes';
import { DATE_FORMAT_TO_DISPLAY, IMAGE_BASE_NAME_FORMAT, MIN_DATE } from '../../config';
import moment from 'moment';
import Slider from '@mui/material/Slider';
import { Box } from '@mui/material';

import CircularProgress from '@mui/material/CircularProgress';
import CustomSlider from '../CustomSlider/CustomSlider';

const Principal = () => {
    const listadoHorario = useMemo(() => generaListadoHorario(), [])
    const [listadoImagenes, setListadoImagenes] = useState([])
    const [fechaMuestra, setFechaMuestra] = useState(MIN_DATE.utc().format('DD/MM/YYYY HH:mm'))
    const [velocidad, setVelocidad] = useState(800)
    const [idReproduccion, setIdReproduccion] = useState(0)
    const [posicion, setPosicion] = useState(0);
    const [reproduciendo, setReproduciendo] = useState(0)



    const { images: imagenes_ricm, error: error_ricm, isLoading: isLoading_ricm, urls: urls_ricm } = useLoadImages(
        {
            prefijo: '',
            sufijo: '_rf',
            listadoImagenes: listadoHorario,
            posicion,
            extencion: 'png',
        })



    const imagenAnerior = () => posicion === listadoImagenes.length - 1 ? setPosicion(0) : setPosicion(posicion + 1)

    const imagenSiguiente = useCallback(() => {
        posicion === 0 ? setPosicion(listadoImagenes.length - 1) : setPosicion(posicion - 1)
    }, [posicion, setPosicion, listadoImagenes]);


    const formatearFechaMuestra = useCallback(() => {
        if (listadoImagenes.length === 0) return
        const date = moment(listadoImagenes[posicion].dateTime, IMAGE_BASE_NAME_FORMAT)
        setFechaMuestra(date.format(DATE_FORMAT_TO_DISPLAY))
    }, [posicion, listadoImagenes])


    const disminuirVelocidad = () => setVelocidad(velocidad + 100)
    const aumentarVelocidad = () => setVelocidad(velocidad - 100)
    const pause = () => clearInterval(idReproduccion, setReproduciendo(0,))
    const reproducir = () => { if (reproduciendo === 0) setReproduciendo(1) }
    const stop = () => clearInterval(idReproduccion, setReproduciendo(0, setPosicion(0, setIdReproduccion(0))))


    const generaListadoImagenes = useCallback(() => {
        const listadoImagenes = []
        listadoHorario.forEach((fecha) => {
            if (imagenes_ricm[fecha] && imagenes_ricm[fecha]) listadoImagenes.push({ ricm: imagenes_ricm[fecha], dateTime: fecha, urls_ricm: urls_ricm[fecha] })
        })

        setListadoImagenes(listadoImagenes)

    }, [imagenes_ricm, urls_ricm, listadoHorario])




    useEffect(() => {
        generaListadoImagenes()
    }, [isLoading_ricm, generaListadoImagenes])

    useEffect(() => {
        if (reproduciendo === 1) {
            setTimeout(() => {
                imagenSiguiente()
            }, velocidad)
        }
        formatearFechaMuestra()
    }, [reproduciendo, posicion, idReproduccion, velocidad, imagenSiguiente, formatearFechaMuestra])




    if (isLoading_ricm || listadoImagenes.length < 1) return <Box
        sx={{
            display: "flex",
            width: "100vw",
            height: "100vh",
            justifyContent: "center",
            alignItems: "center",
            justifyItems: "center",
        }}
    >
        <CircularProgress color="primary" />

    </Box>

    return (
        <Box
            sx={{
                maxWidth: "100vw",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Botonera
                stop={stop}
                pause={pause}
                aumentarVelocidad={aumentarVelocidad}
                disminuirVelocidad={disminuirVelocidad}
                reproducir={reproducir}
                imagenSiguiente={imagenSiguiente}
                imagenAnerior={imagenAnerior}
                reproduciendo={reproduciendo}
            />

            <CustomSlider reproduciendo={reproduciendo} listadoImagenes={listadoImagenes} posicion={posicion} setPosicion={setPosicion} fechaMuestra={fechaMuestra} />

            <Box
                sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    maxWidth: "100vw",
                    maxHeight: "100vh",
                    justifyContent: "center",
                }}
            >
                <Imagen src={listadoImagenes[posicion].ricm} downloadLink={listadoImagenes[posicion].urls_ricm.replace('.png', '.tif')} error={error_ricm} />

            </Box>
        </Box>
    );
}







export default Principal;